// helpers.ts — Pure utility functions for N211 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number with locale grouping, max 4 decimals (for exchange rate) */
export const fmtRate = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 4 });
};

/** Calculate detail row amount: qty * price, rounded to 2 decimals */
export const calcAmount = (qty: number, price: number): number => {
  return Math.round(qty * price * 100) / 100;
};

/** Invoice type options */
export const INVOICE_TYPE_OPTIONS = [
  { value: 1, label: '三聯式' },
  { value: 2, label: '二聯式' },
  { value: 3, label: '外銷發票-零稅率' },
  { value: 4, label: '不開票-內銷' },
  { value: 5, label: '不開票-外銷' },
];

/** Get invoice type label */
export const getInvoiceTypeLabel = (v: number | null | undefined): string => {
  const opt = INVOICE_TYPE_OPTIONS.find(o => o.value === v);
  return opt ? opt.label : '';
};

/** Fields that are always readonly (system-managed) */
const ALWAYS_READONLY = new Set([
  'fn210_01', 'fn210_10', 'fn210_18', 'fn210_20', 'fn210_201',
  'fn210_21', 'fn210_22', 'fn210_24', 'fn210_26', 'fn210_80',
]);

/** Fields that become readonly in edit mode (not changeable after creation) */
const EDIT_READONLY = new Set([
  'fn210_11', // delivery date not editable in modify mode
]);

/** Check if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  if (mode === 'edit' && EDIT_READONLY.has(key)) return true;
  return false;
};

/** Derive the status badge for a record */
export const getStatusBadge = (record: { fn210_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fn210_80 || '').trim();
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  return null;
};
